import { Swiper, FreeMode } from 'swiper';

const moveFirstSlide = (swiper) => {
  let marginLeft = 0;

  if (swiper.slides.length > 0) {
    if (document.documentElement.clientWidth < 768) {
      marginLeft = 220;
    } else if (document.documentElement.clientWidth < 992) {
      marginLeft = swiper.slides[0].offsetWidth * 0.66;
    } else {
      marginLeft = swiper.slides[0].offsetWidth * 0.35;
    }
  }

  swiper.setTranslate(-marginLeft);
};
const collage = (block = document) => {
  const swiperContainerClass = '.collage__swiper';
  const sliders = block.querySelectorAll(swiperContainerClass);

  sliders.forEach((slider) => {
    // eslint-disable-next-line no-new
    const swiper = new Swiper(slider, {
      slidesPerView: 'auto',
      autoHeight: false,
      spaceBetween: 20,
      freeMode: {
        enabled: true,
        sticky: false,
      },
      modules: [FreeMode],
      breakpoints: {
        768: {
          spaceBetween: 40,
          slidesPerView: 1.8,
          initialSlide: 1,
          centeredSlides: true,
          slidesOffsetBefore: 0,
        },
        992: {
          initialSlide: 0,
          centeredSlides: false,
          spaceBetween: 40,
          slidesPerView: 3.5,
        },
      },
      on: {
        resize: moveFirstSlide,
        click: (currentSwiper, event) => {
          const width = document.documentElement.clientWidth;
          if (event.clientX < width * 0.25) {
            currentSwiper.slidePrev();
          } else if (event.clientX > width * 0.75) {
            currentSwiper.slideNext();
          }
        },
      },
    });

    document.addEventListener('preloaderDone', () => {
      moveFirstSlide(swiper);
    });
  });
};

document.addEventListener('DOMContentLoaded', () => {
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds/collage', ($block) => {
      collage($block[0]);
    });
  }
});

export default collage;
